import Image from "next/image";
import { storyblokEditable } from "@storyblok/react/rsc";

import { GridContainer } from "@/components/layout/GridContainer";
import type { AssetStoryblok } from "@/component-types-sb";

type ImageSectionStoryblok = {
  image: AssetStoryblok;
  _uid: string;
  component: "image_section";
};

type ImageSectionProps = {
  blok: ImageSectionStoryblok;
};

const ImageSection = ({ blok }: ImageSectionProps) => {
  if (!blok.image?.filename) return null;

  return (
    <div className="py-8" {...storyblokEditable(blok)}>
      <GridContainer className="!px-0">
        <div className="col-span-12 lg:col-span-10 lg:col-start-2 rounded-3xl overflow-hidden aspect-video lg:aspect-[21/9]">
          <Image
            src={blok.image.filename}
            alt={blok.image.alt || ""}
            width={1200}
            height={675}
            className="w-full h-full object-cover"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 83vw, 1000px"
          />
        </div>
      </GridContainer>
    </div>
  );
};

export default ImageSection;
